import React from "react";
import Seo from "@/components/vlyt/Seo";
import { Mail, Linkedin, Instagram } from "lucide-react";

const FOUNDER_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_vlyt-launch/artifacts/4qzdiagx_1282917b-656b-4ef2-ab12-0529767ce0eb.jpeg";
const FOUNDER_IMG_ALT = "https://customer-assets-agu9un31.emergentagent.net/job_vlyt-launch/artifacts/bhcnnkob_da8cc5d0-e354-400e-bf2a-db53a741d455.jpeg";

export default function Founder() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": "https://govlyt.com/#founder",
    name: "Miesindou Alagha",
    jobTitle: "Founder & Strategic Architect",
    worksFor: { "@type": "Organization", name: "Vlyt Technologies" },
    url: "https://govlyt.com/about/miesindou",
    sameAs: [
      "https://scholar.google.com/scholar?cluster=852375541475616738",
      "https://www.researchgate.net/institution/Covenant-University/members/81",
      "https://www.instagram.com/p/DE7LbA8sXug/",
      "https://rocketreach.co/covenant-university-student-council-profile_b6a54b2ac87fe612",
      "https://ng.linkedin.com/in/mikeal-alagha",
    ],
  };
  return (
    <>
      <Seo
        title="Miesindou Alagha · Founder of Vlyt"
        canonical="https://govlyt.com/about/miesindou"
        jsonLd={jsonLd}
      />
      <section className="pt-[120px] pb-16 mx-auto max-w-[1440px] px-5 md:px-10 grid lg:grid-cols-[1fr_1.2fr] gap-12 items-start">
        <div className="rounded-[24px] overflow-hidden border border-[color:var(--vlyt-border)] shimmer-border">
          <div className="inner p-2">
            <img
              src={FOUNDER_IMG}
              alt="Miesindou Alagha portrait"
              className="w-full aspect-[4/5] object-cover rounded-[18px]"
              loading="lazy"
            />
          </div>
        </div>
        <div>
          <div className="text-eyebrow mb-4">Founder Profile</div>
          <h1 className="text-h1 font-display">Miesindou Alagha</h1>
          <div className="mt-2 text-[color:var(--vlyt-muted)] font-mono uppercase tracking-widest text-[12px]">
            Founder · Strategic Architect · Covenant University
          </div>

          <div className="mt-8 space-y-5 text-[color:var(--vlyt-text)] text-[16px] leading-relaxed">
            <p>
              Founder and Strategic Architect of Vlyt Technologies. A penultimate student and
              Student Council Public Relations Officer at Covenant University, Miesindou is
              applying <span className="text-lime">&lsquo;Accurate Thinking&rsquo;</span> to bridge
              the gap between human psychology and community logistics.
            </p>
            <p>
              He leads Vlyt&rsquo;s product, partnerships, and driver network. When he is not
              shipping, he is on the ground with the driver cohort at Hebron gate, listening.
            </p>
            <p className="text-[color:var(--vlyt-muted)]">
              &ldquo;Vlyt will not be a giant. It will be dependable. Every student who taps
              &lsquo;ride&rsquo; should feel they have made a certain decision.&rdquo;
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a href="mailto:miesindou@govlyt.com" className="btn-ghost">
              <Mail size={14} /> miesindou@govlyt.com
            </a>
            <a href="https://ng.linkedin.com/in/mikeal-alagha" target="_blank" rel="noreferrer" className="btn-ghost">
              <Linkedin size={14} /> LinkedIn
            </a>
            <a href="https://instagram.com/senalagha" target="_blank" rel="noreferrer" className="btn-ghost">
              <Instagram size={14} /> @senalagha
            </a>
          </div>
        </div>
      </section>

      {/* Secondary photo panel */}
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-24">
        <div className="rounded-[24px] overflow-hidden border border-[color:var(--vlyt-border)] bg-[color:var(--vlyt-surface-1)] grid lg:grid-cols-[1.2fr_1fr] gap-0">
          <div className="relative min-h-[420px]">
            <img
              src={FOUNDER_IMG_ALT}
              alt="Miesindou Alagha at Covenant University"
              className="absolute inset-0 h-full w-full object-cover"
              style={{ objectPosition: "50% 20%" }}
              loading="lazy"
            />
          </div>
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <div className="text-eyebrow mb-5">On the ground</div>
            <h2 className="text-h2 font-display leading-[1.15]">
              Built from inside <span className="text-lime">Hebron.</span>
            </h2>
            <p className="mt-6 text-[color:var(--vlyt-muted)] text-[16px] leading-relaxed">
              Vlyt is not a Silicon Valley export. It is a system engineered by a Covenant student
              who walks the same corridors, waits at the same gates, and rides with the same
              drivers. That proximity is the moat.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3 text-[13px] font-mono uppercase tracking-widest">
              <div><span className="text-[color:var(--vlyt-purple-soft)]">Role</span> · Strategic Architect</div>
              <div><span className="text-[color:var(--vlyt-purple-soft)]">Institution</span> · Covenant University</div>
              <div><span className="text-[color:var(--vlyt-purple-soft)]">Class</span> · 2027</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
